import { createStore } from 'vuex';

const store = createStore({
  state() {
    return {
      tasks: [], // Cache tasks here
      taskDetails: null, // Store details for the currently viewed task
    };
  },
  mutations: {
    setTasks(state, tasks) {
      state.tasks = tasks;
    },
    setTaskDetails(state, task) {
      state.taskDetails = task;
    },
  },
});

export default store;
